import { MentoraXDashboard } from "@/components/mentorax/MentoraXDashboard";

export const Dashboard = () => <MentoraXDashboard />;
